import * as React from 'react';
import {useNavigate} from "react-router-dom";
import Top from "../Top";

import Box from '@mui/material/Box';
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import {styled} from '@mui/material/styles';
import {Typography} from '@mui/material';
import BusinessRoundedIcon from '@mui/icons-material/BusinessRounded';
import PersonOutlineRoundedIcon from '@mui/icons-material/PersonOutlineRounded';
import api from "../../utils/api";
import axios from 'axios';
import tabbg from "../../assets/images/tab_05.png"

const Join = () => {
  const navigate = useNavigate();
  
  async function handleGoNiceAuth(joinDiv :any){
    // const apiUrl = (process.env.REACT_APP_API_URL || '');
    const returnUrl = (process.env.REACT_APP_NICE_API || '') + '/v1/nice/decrypt/data', 
          redirectUrl = `${window.location.protocol}//${window.location.host}/${joinDiv}`,
          customize = '';

		const params = {
			customize: customize, // "" : 기본 Popup || "Mobile" : 모바일페이지
			returnUrl: returnUrl,
			redirectUrl: redirectUrl
		};
    
    api.get((process.env.REACT_APP_NICE_API || '') + '/v1/nice/encrypt/data', {params}).then(res => { //{withCredentials: false}
      
      const input0 = document.createElement("input");
      input0.type = "hidden";
      input0.setAttribute("name", "recvMethodType");
      input0.setAttribute("value", "get");
      
      const input1 = document.createElement("input");
      input1.type = "hidden";
      input1.setAttribute("name", "EncodeData");
      input1.setAttribute("value", res.data);
      
      const input2 = document.createElement("input");
      input2.type = "hidden";
      input2.setAttribute("name", "m");
      input2.setAttribute("value", 'checkplusService');
      
      let form = document.createElement("form");
      form.method = 'post';
      form.action = 'https://nice.checkplus.co.kr/CheckPlusSafeModel/checkplus.cb';
      form.appendChild(input0);
      form.appendChild(input1);
      form.appendChild(input2);
      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);
      
    }).catch(function (error) {
      console.log(error);
    });
    
  }
  
  const img = {
    backgroundImage: `url(${tabbg})`, backgroundSize: 'cover', mb: 5, borderRadius: 2, width: '100%', height: 200, mt: 1
  }
  
  
  return (
    <Container sx={Logbg}>
      <Box sx={img}><Typography sx={{ color: '#fff', textAlign: 'center', fontSize: 25, lineHeight: '200px' }}>회원 가입</Typography></Box>

      {/* <Box sx={{pb: 5, width: '30%', m: '0 auto' }}>
        <Img alt="DualLogo" src="/dualLogin.png" />
      </Box> */}

      <Typography component={'div'} sx={{ textAlign: 'center', fontSize: 20, fontWeight: 700, color: '#666' }}>회원 구분 선택</Typography>

      <Stack direction={'column'} sx={{ mt: 2, justifyContent: 'center', alignContent: 'center' }}>
        <Stack direction={'column'}
          sx={{ alignItems: 'center', mb: 1, p: '40px 15px', bgcolor: '#fff', width: '60%', ml: 'auto', mr: 'auto', justifyContent: 'center', borderRadius: 5 }}
          onClick={() => handleGoNiceAuth('Join/OfficeJoin')} >
          <Box sx={{ bgcolor: '#FEF3EF', p: 2, borderRadius: '50%', width: '60px', height: '60px' }}>
            <BusinessRoundedIcon sx={{ color: '#FFAA2C', fontSize: 60, position: 'relative', top: '8px' }} />
          </Box>
          <Typography sx={{ position: 'relative', top: '-15px', bgcolor: '#fff', p: 1, color: '#555', fontWeight: 700, fontSize: 18 }}>기업회원</Typography>
          <Typography sx={{ fontSize: 14, color: '#555', mt: '-10px' }}>듀얼헬스케어와 서비스 제공 협약이 체결된 사업장의 재직 임직원 가족 및 지인</Typography>
        </Stack>

        <Stack direction={'column'}
          sx={{ alignItems: 'center', mt: 3, mb: 1, p:  '40px 15px', bgcolor: '#fff', width: '60%', ml: 'auto', mr: 'auto', justifyContent: 'center', borderRadius: 5 }}
          onClick={() => handleGoNiceAuth('Join/UserJoin')} >
          <Box sx={{ bgcolor: '#FEF3EF', p: 2, borderRadius: '50%', width: '60px', height: '60px' }}>
            <PersonOutlineRoundedIcon sx={{ color: '#FFAA2C', fontSize: 60, position: 'relative', top: '10px' }} />
          </Box>
          <Typography sx={{ position: 'relative', top: '-15px', bgcolor: '#fff', p: 1, color: '#555', fontWeight: 700, fontSize: 18 }}>개인회원</Typography>
          <Typography sx={{ fontSize: 14, color: '#555', mt: '-10px' }}>듀얼헬스케어의 서비스를 이용하고자 하는 개인</Typography>
        </Stack>
      </Stack>

    </Container>
  );
}

const BottomBtnStyle = {
  width: '100%',
  bgcolor: '#ef8322',
  fontSize: 18,
  fontWeight: 700,
  borderRadius: '10px',
  boxSizing: 'border-box',
  color: '#fff',
  border: '1px solid #ef8322',
  mt: 4,
  mb: 1,
  ':hover': {
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
    boxShadow: 'none',
    color: '#fff'
  },
  ':active': {
    boxShadow: 'none',
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
  },
  ':focus': {
    boxShadow: 'none',
  },
};

const Img = styled('img')({
  margin: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
});
const loginField = {
  width: '97%',
  '& label': {
    color: '#aaa',
  },
  '& label.Mui-focused': {
    color: '#ef8322',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: '#ef8322',
  },
  '& .MuiInputBase-root:before': {
    borderBottomColor: '#bbb',
  }
};

const Logbg = {
  bgcolor: '#f5f5f5',
  height: '100%',
  minHeight: '100vh',
  pb: 4,
  minWidth: '320px'
}

export default Join;